import { h, JSX } from 'preact'

import { TextInputProps, TextInputWrapper } from '../text-input'

export interface TextfieldProps extends TextInputProps {
    name?: string
    type?: string
    onChange?: (value: string) => void
    placeholder?: string
    attributes?: JSX.HTMLAttributes<HTMLInputElement>
}

export const Textfield = (props: TextfieldProps): JSX.Element => {
    const { name, type, onChange, placeholder, attributes, ...wrapperProps } = props

    const { id, value, isDisabled } = wrapperProps

    return (
        <TextInputWrapper
            {...wrapperProps}
            renderInput={({ ref, onFocus, onBlur }) => (
                <input
                    ref={ref}
                    class="form-textfield__input"
                    type={type || 'text'}
                    id={id}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    disabled={isDisabled}
                    onInput={(event): void => onChange?.(event.currentTarget.value)}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    {...attributes}
                />
            )}
        />
    )
}
